import styled from 'styled-components';

export const StyledUserPanelEmployeeConf = styled.div`
    width: 100%;
    height: 100%;
`;
